import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  getTemplateItemMaster as getTemplateItemMasterAPI,
  putTemplateItemMaster,
  TemplateItemMasterParams,
} from './api';
import { PutTemplateItemMaster, Status } from '../../services/apiTypes';

interface StatusState {
  status: Status;
}

const initialState: StatusState = {
  status: 'idle',
};

export const getTemplateItemMaster = createAsyncThunk(
  'templateItem/getTemplateItemMaster',
  async (params: TemplateItemMasterParams, { rejectWithValue }) => {
    try {
      return await getTemplateItemMasterAPI(params);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const updateTemplateItemMaster = createAsyncThunk(
  'templateItem/updateTemplateItemMaster',
  async (newTemplateItem: PutTemplateItemMaster, { rejectWithValue }) => {
    try {
      return await putTemplateItemMaster(newTemplateItem);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const templateItemSlice = createSlice({
  name: 'templateItem',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTemplateItemMaster.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getTemplateItemMaster.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(getTemplateItemMaster.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(updateTemplateItemMaster.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateTemplateItemMaster.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(updateTemplateItemMaster.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export default templateItemSlice.reducer;
